export const APP_VIEWPORT_HEIGHT_VAR = '--app-viewport-height';
export const APP_VIEWPORT_HEIGHT = `var(${APP_VIEWPORT_HEIGHT_VAR}, 100vh)`;

export const viewportHeightWithOffset = (offsetPx: number) =>
  `calc(${APP_VIEWPORT_HEIGHT} - ${offsetPx}px)`;

export const initializeViewportHeightVar = () => {
  if (typeof document === 'undefined') return;

  const supportsDynamicViewport =
    typeof window !== 'undefined' && !!window.CSS?.supports?.('height: 100dvh');

  document.documentElement.style.setProperty(
    APP_VIEWPORT_HEIGHT_VAR,
    supportsDynamicViewport ? '100dvh' : '100vh'
  );
};
